import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable @upgrade/require-palette-colors-jsx-attrs */
import React from 'react';
const Compact = ({
  width = 110,
  height = 110,
  viewBox = '0 0 110 110',
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: width,
  height: height,
  viewBox: viewBox
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M54.714 96.64c25.912-8.543 41.3-34.36 35.997-60.39-20.649-17.408-51.397-17.322-71.942.201-5.186 25.947 10.152 51.63 35.945 60.19z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-88.63 93.354 77.884)",
  cx: "93.354",
  cy: "77.884",
  rx: "9.942",
  ry: "10.255"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-74.995 16.577 78.175)",
  cx: "16.577",
  cy: "78.175",
  rx: "10.006",
  ry: "10.278"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-24.19 54.781 13.295)",
  cx: "54.781",
  cy: "13.295",
  rx: "10.203",
  ry: "9.995"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.907 10.236l1.542-.798c-.555.26-1.048.53-1.542.798zM25.906 11.386l.866-.537-.866.537z",
  fill: "#ABCED4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.77 36.451c9.948-8.506 22.757-13.2 36.022-13.2-5.55-.15-9.972-4.55-9.979-9.934-.007-5.383 4.403-9.795 9.953-9.958A55.747 55.747 0 0029.83 9.237a56.29 56.29 0 016.834-2.839c-9.275 7.787-15.578 18.373-17.895 30.053z",
  fill: "#A8B5DA",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.831 8.271c.486.218.97.445 1.447.68a32.44 32.44 0 00-1.447-.68zM75.354 7.238a46.78 46.78 0 011.672.689 27.387 27.387 0 00-1.672-.689zM72.972 6.356zM80.274 9.438c.416.21.823.428 1.23.655-.407-.227-.814-.437-1.23-.655zM109.498 58.367c0 .361 0 .722-.052 1.083l.052-1.083zM109.55 56.327v-.563 1.251c-.018-.235 0-.453 0-.688zM109.333 61.012c0 .277-.06.554-.087.84.026-.286.061-.554.087-.84zM109.03 63.59c0 .227-.07.445-.104.672.035-.227.078-.445.104-.672zM108.588 66.277v-.227V66.277z",
  fill: "#ABCED4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.039 13.292c.004 5.493-4.582 9.95-10.247 9.96 13.203-.036 25.97 4.583 35.919 12.998-2.352-11.656-8.675-22.207-17.955-29.96a56.125 56.125 0 00-17.99-2.931C60.431 3.354 65.03 7.8 65.04 13.292z",
  fill: "#A8B5DA",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.621 10.715l1.178.688-1.178-.688zM87.368 13.754l.424.31-.424-.31zM109.428 53.01c0 .47.052.94.07 1.419a74.258 74.258 0 00-.07-1.42zM85.038 12.176l.866.554-.866-.554zM101.538 28.76zM102.802 30.876a51.97 51.97 0 016.332 18.868 51.583 51.583 0 00-6.332-18.868zM109.134 50.256c.078.588.13 1.175.182 1.771a12.168 12.168 0 00-.182-1.771z",
  fill: "#ABCED4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.535 102.35a55.147 55.147 0 01-8.402-5.777 56.31 56.31 0 0035.581.067c-12.486-4.128-23.002-12.51-29.596-23.587 2.844 4.752 1.176 10.838-3.724 13.595-4.901 2.757-11.18 1.14-14.023-3.61 14.428 24.145 45.688 33.322 71.509 20.992-16.337 7.76-35.585 7.13-51.345-1.68z",
  fill: "#A8B5DA",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.128 102.359l.597-.353c-.364.21-.727.42-1.1.613l.503-.26zM80.698 103.115a51.76 51.76 0 000 0zM84.579 100.89l-.407.251.407-.252z",
  fill: "#ABCED4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.104 69.443c4.9-2.749 11.169-1.134 14.014 3.61-6.624-11.056-8.883-24.069-6.357-36.619C9.596 44.24 3.386 54.791 1.117 66.411A50.898 50.898 0 01.13 56.47C.093 38.833 9.11 22.336 24.183 12.461.303 28.038-7.045 58.887 7.37 83.037c-2.84-4.753-1.169-10.839 3.733-13.594z",
  fill: "#A8B5DA",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ABCED4",
  fillRule: "nonzero",
  d: "M27.3 10.555l-.45.294 1.1-.613zM24.191 12.453c.563-.37 1.144-.722 1.733-1.067-.598.37-1.17.697-1.733 1.067zM29.449 9.438l.38-.201-.38.201z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.13 56.47c.002 3.336.333 6.665.987 9.941 2.275-11.615 8.488-22.16 17.652-29.96 2.315-11.683 8.618-22.272 17.895-30.06-2.341.798-4.625 1.75-6.834 2.846l-.381.201-1.499.798-1.1.613-.866.537c-.571.345-1.152.697-1.732 1.067C9.15 22.313.106 38.818.13 56.469z",
  fill: "#383E52",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.119 10.412l-.615-.336c.372.202.745.403 1.117.622l-.502-.286zM79.278 8.951l.996.487-.996-.487zM72.756 6.273l.208.067zM77.087 7.927l.788.344-.788-.344zM74.722 6.986l.65.252-.65-.252zM85.878 12.73c.502.336 1.005.672 1.49 1.024-.485-.319-.988-.688-1.49-1.024zM109.446 59.45c0 .521-.07 1.042-.113 1.562.043-.554.078-1.041.113-1.562zM109.532 57.015v1.352a23.45 23.45 0 010-1.352zM83.8 11.403l1.238.773-1.239-.773zM109.498 54.429v1.335c.026-.445.017-.89 0-1.335zM109.246 61.844c-.06.587-.13 1.167-.216 1.746.104-.613.156-1.159.216-1.746zM109.35 52.061c0 .328.052.647.078.983l-.078-.983zM102.205 29.81c.208.352.424.705.632 1.066a9.266 9.266 0 01-.632-1.067zM108.926 64.262c-.087.596-.19 1.192-.303 1.788a33.61 33.61 0 00.303-1.788zM109.134 49.744c0 .167.052.344.07.512-.07-.168-.07-.345-.07-.512zM101.538 28.76a53.21 53.21 0 00-13.746-14.695 54.034 54.034 0 0113.746 14.695z",
  fill: "#ABCED4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.711 36.25c2.572 12.553.353 25.584-6.245 36.67 1.719-3.28 5.165-5.373 8.959-5.439 3.794-.066 7.316 1.905 9.155 5.123a9.684 9.684 0 01-.375 10.24 51.7 51.7 0 006.34-16.584C106.242 54.6 99.96 44.03 90.71 36.25z",
  fill: "#A8B5DA",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.711 36.25c9.263 7.775 15.557 18.346 17.869 30.01v-.21c.112-.596.216-1.192.303-1.788 0-.227.078-.445.104-.672.086-.58.156-1.159.216-1.746 0-.278.06-.555.087-.84 0-.52.078-1.041.112-1.562 0-.361 0-.722.052-1.083s0-.899 0-1.352v-1.251-1.335c0-.445 0-.95-.069-1.42 0-.335-.052-.654-.078-.982a39.6 39.6 0 00-.182-1.772c0-.168-.043-.344-.07-.512a51.965 51.965 0 00-6.296-18.868c-.208-.36-.424-.714-.632-1.066-.208-.353-.416-.706-.633-1.05A54.034 54.034 0 0087.75 14.056l-.425-.31a46.07 46.07 0 00-1.49-1.025l-.865-.554-1.24-.772-1.177-.689c-.269-.21-.676-.411-1.048-.63a23.306 23.306 0 00-1.23-.655l-.996-.487a45.103 45.103 0 00-1.447-.68l-.744-.327a46.78 46.78 0 00-1.672-.689l-.65-.252c-.58-.218-1.169-.428-1.732-.63l-.277-.067c9.28 7.754 15.603 18.305 17.955 29.96z",
  fill: "#383E52",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.172 101.141c-.477.294-.962.58-1.447.84.485-.252.97-.546 1.447-.84z",
  fill: "#ABCED4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.234 86.489c-2.36-1.317-4.082-3.488-4.789-6.036a9.677 9.677 0 011.021-7.55c-6.607 11.155-17.186 19.59-29.752 23.72a56.308 56.308 0 0035.806-.083 54.46 54.46 0 01-5.941 4.333c7.272-4.564 13.314-10.745 17.626-18.029-2.83 4.735-9.073 6.364-13.971 3.645z",
  fill: "#A8B5DA",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.625 102.62c-.303.175-.615.335-.927.495l.927-.496z",
  fill: "#ABCED4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.714 96.64a56.31 56.31 0 01-35.58-.075c16.585 13.858 40.098 16.792 59.763 7.456.615-.285 1.212-.596 1.81-.906.312-.16.624-.32.927-.496.303-.176.736-.403 1.1-.613.364-.21.97-.57 1.446-.84l.407-.251a54.46 54.46 0 005.942-4.333 56.308 56.308 0 01-35.815.058z",
  fill: "#383E52",
  fillRule: "nonzero"
}))));
export default Compact;
//# sourceMappingURL=compact-dark.js.map